import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";

const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen bg-background text-foreground flex">
    <div className="hidden lg:flex flex-col justify-between w-1/2 relative p-12 border-r border-white/10 overflow-hidden">
      <div className="absolute inset-0 grid-glow opacity-30" />
      <div className="absolute top-20 -left-20 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[140px]" />
      <div className="relative"><Logo /></div>
      <div className="relative">
        <h2 className="font-heading text-4xl font-black tracking-tight leading-tight">Grow your TikTok<br />on autopilot.</h2>
        <p className="mt-4 text-muted-foreground max-w-md">Real, targeted followers. Live analytics. Zero bots. Welcome back to your growth engine.</p>
        <div className="mt-10 flex gap-8">
          <div><div className="font-heading text-3xl font-black text-primary">4.2M+</div><div className="text-xs uppercase tracking-widest text-muted-foreground">Followers gained</div></div>
          <div><div className="font-heading text-3xl font-black text-primary">12K+</div><div className="text-xs uppercase tracking-widest text-muted-foreground">Creators</div></div>
        </div>
      </div>
      <div className="relative text-xs text-muted-foreground">© {new Date().getFullYear()} CloutRise</div>
    </div>
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="lg:hidden mb-8"><Logo /></div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground mt-2 mb-8">{subtitle}</p>
        {children}
        <p className="mt-6 text-sm text-muted-foreground text-center">{footer}</p>
      </div>
    </div>
  </div>
);

export const GoogleButton = ({ label = "Continue with Google" }) => {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button onClick={handleGoogle} data-testid="google-login-btn"
      className="w-full h-11 rounded-full border border-white/15 bg-white/5 hover:bg-white/10 transition-colors flex items-center justify-center gap-3 font-medium text-sm">
      <svg className="w-4 h-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
      {label}
    </button>
  );
};

export default AuthShell;
